/*
  PC ヘッダーの丸い点（現在地・ホバーの印）を「日本語の字の下端」と「ヘッダーの境界線」のちょうど真ん中に置く（2026/9/29 松見さん）。
  - 数値を決め打ちしない：字の大きさ・行間・ヘッダーの高さが変わっても、毎回測って置き直す
  - 「字の下端」は行の箱ではなく字そのものの下端（行の箱には字の下に余白がある）。
    日本語の字の下端＝ベースライン＋漢字「国」の下への出（Range と canvas の measureText で、その場の書体・大きさで測る）
    ※ daytune. の y のような英字の下への出は含めない（全項目で同じ高さに揃えるため漢字の基準で測る）
  - 境界線＝.header の下端から border-bottom の太さを引いた位置（線の上端）
  - 点の中心＝（字の下端＋線の上端）÷ 2。CSS 変数 --dt-dot-top（その項目の下端からの距離）を項目ごとに入れる
  - 使う CSS＝assets/custom.css.liquid の .header.dt-dot-ready ... :after（JS が動く前は従来の位置のまま）
  - 子メニューの板の上端もヘッダーの線に合わせる（--dt-board-top）＝板が点を隠さない
  - 測る時機＝読み込み時・Web フォント読込後・画面幅の変更・ヘッダーの色が変わった時（トップのスクロール）

  丸い点が親メニューの間を滑る動き（2026/10/01 松見さん）
  - 1 段目の親メニューの点は項目ごとの :after をやめ、ナビに 1 つだけ置く .dt-nav-dot（aria-hidden）に切り替える。
    切り替えは .header に dt-dot-slide が付いた時だけ＝JS が動かない・990px 未満・スマホは従来の項目ごとの点のまま
  - 縦位置は上の --dt-dot-top の考え方そのまま（項目ごとの点と同じ高さ）。横位置は対象の英字の中央
  - 位置は transform: translate だけで動かす（レイアウトに触れない）。ヘッダー全体には transform / filter 等を付けない（板の磨りガラスが効かなくなる）
  - 対象＝マウスが乗っている親 > キーボードのフォーカス > 板が開いている親 > 今のページの項目。どれも無ければ 0.3s でふっと消える
  - 消えている状態から出る時は滑らせず、その場に現れる（左端から飛んでこない）。reduce motion では滑らせない
  - 画面幅・フォント・色の変化での測り直しは滑らせない（place() の後に位置だけ更新）
*/
(function () {
  var ITEM_SEL = '.header__inline-menu > ul > li > header-menu > details > summary.header__menu-item, .header__inline-menu > ul > li > a.header__menu-item, .header__util__link';
  var PARENT_SEL = '.header__inline-menu > ul > li > header-menu > details > summary.header__menu-item, .header__inline-menu > ul > li > a.header__menu-item';
  var dot = null;
  var dotOn = false;
  var lastTarget = null;
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  // 2026/10/06 Codex 事後レビュー P2-2: :focus-visible 非対応（Safari 15.4 未満）では querySelector が例外を投げ、
  // キーボード操作中だけ点の同期が止まる。Dawn の global.js（focusVisiblePolyfill）が付ける .focused に切り替える
  var FOCUS_SEL = ':focus-visible';
  try { document.querySelector(FOCUS_SEL); } catch (e) { FOCUS_SEL = '.focused'; }
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');

  function jaInkBottom(ja) {
    // 字の下端＝ベースライン＋漢字「国」の下への出。
    // ベースライン＝文字の範囲（Range）の下端 − 書体の下への余白（fontBoundingBoxDescent）。
    // Range の箱は行間（line-height）に左右されず、書体の上下の余白だけを含む＝字の位置そのものに付く
    var range = document.createRange();
    range.selectNodeContents(ja);
    var rects = range.getClientRects();
    if (!rects.length) return null;
    var bottom = rects[rects.length - 1].bottom;
    var cs = getComputedStyle(ja);
    ctx.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
    var m = ctx.measureText('国');
    return bottom - (m.fontBoundingBoxDescent || 0) + (m.actualBoundingBoxDescent || 0);
  }

  function place() {
    var header = document.querySelector('.header');
    if (!header) return;
    var hr = header.getBoundingClientRect();
    var line = hr.bottom - (parseFloat(getComputedStyle(header).borderBottomWidth) || 0);
    var ok = false;
    document.querySelectorAll(ITEM_SEL).forEach(function (item) {
      var ja = item.querySelector('.nav__item__ja, .header__util__ja');
      if (!ja || !ja.offsetParent) return; // 表示されていない（990px 未満など）
      var ink = jaInkBottom(ja);
      if (ink === null) return;
      var dotH = parseFloat(getComputedStyle(item, '::after').height) || 4;
      var center = (ink + line) / 2;
      var top = center - dotH / 2 - item.getBoundingClientRect().top; // 項目の上端からの距離
      item.style.setProperty('--dt-dot-top', top.toFixed(2) + 'px');
      ok = true;
    });
    // 子メニューの板の上端＝ヘッダーの線（details の下端からの距離を --dt-board-top に）。点は線より上なので板に隠れない
    document.querySelectorAll('.header__inline-menu > ul > li > header-menu > details').forEach(function (d) {
      var s = d.querySelector('summary');
      if (!s || !s.offsetParent) return;
      d.style.setProperty('--dt-board-top', (line - s.getBoundingClientRect().bottom).toFixed(2) + 'px');
    });
    header.classList.toggle('dt-dot-ready', ok);
    var slide = ok && Array.prototype.some.call(document.querySelectorAll(PARENT_SEL), function (it) { return it.offsetParent; });
    header.classList.toggle('dt-dot-slide', slide && ensureDot());
    if (slide) syncDot(false); else if (dot) { dot.classList.remove('is-on'); dotOn = false; }
  }

  // ナビに点を 1 つ作る。置き場所（offsetParent）は測って決めるので、親の position に依存しない
  function ensureDot() {
    if (dot && dot.isConnected) return true;
    var nav = document.querySelector('.header__inline-menu');
    if (!nav) return false;
    dot = document.createElement('span');
    dot.className = 'dt-nav-dot';
    dot.setAttribute('aria-hidden', 'true');
    nav.appendChild(dot);
    dotOn = false;
    lastTarget = null;
    return true;
  }

  // 点が向かう親メニュー: マウス > フォーカス > 板が開いている > 今のページ
  function targetItem() {
    var items = Array.prototype.slice.call(document.querySelectorAll(PARENT_SEL));
    var by = function (fn) { return items.filter(function (it) { return it.offsetParent && fn(it); })[0] || null; };
    var li = function (it) { return it.closest('li'); };
    return by(function (it) { return li(it).matches(':hover'); }) ||
      by(function (it) { return li(it).matches(':focus-within') && !!li(it).querySelector(FOCUS_SEL); }) ||
      by(function (it) { var d = it.parentNode; return d.tagName === 'DETAILS' && d.hasAttribute('open'); }) ||
      by(function (it) { return it.classList.contains('list-menu__item--active') || it.hasAttribute('aria-current'); });
  }

  function syncDot(animate) {
    if (!dot || !dot.isConnected) return;
    var item = targetItem();
    if (!item) { dot.classList.remove('is-on'); dotOn = false; return; }
    var en = item.querySelector('.nav__item__en') || item;
    var er = en.getBoundingClientRect();
    var top = parseFloat(item.style.getPropertyValue('--dt-dot-top'));
    // 縦位置を測れない項目（日本語の添え字が無い等）では、前の項目に点を残さず消す（2026/10/01 Opus の点検 P2-1）
    if (isNaN(top)) { dot.classList.remove('is-on'); dotOn = false; lastTarget = null; return; }
    var dotH = dot.offsetHeight || 4;
    var base = (dot.offsetParent || document.body).getBoundingClientRect();
    var x = er.left + er.width / 2 - base.left - (dot.offsetWidth || 4) / 2;
    var y = item.getBoundingClientRect().top + top - base.top;
    var pos = 'translate(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px)';
    // 🛑 同じ項目への呼び出し（親から親へ移る時は mouseout と mouseover・板の開閉の toggle で何度も来る）では is-sliding に触らない。
    // ここで is-sliding を外すと、動いている滑りの transition が取り消されて瞬間移動になる（2026/10/01 Opus の点検 P1-1）。
    // is-sliding は滑り終わり（transitionend）で外す
    if (dotOn && lastTarget === item) {
      if (dot.style.transform !== pos) dot.style.transform = pos;
      return;
    }
    // 消えている状態から出る時・測り直し・reduce motion は滑らせない
    var slide = animate && dotOn && !(reduce && reduce.matches);
    if (slide) dot.classList.add('is-sliding'); else dot.classList.remove('is-sliding');
    dot.style.transform = pos;
    dot.classList.add('is-on');
    dotOn = true;
    lastTarget = item;
  }

  document.addEventListener('transitionend', function (e) {
    if (e.target === dot && e.propertyName === 'transform') dot.classList.remove('is-sliding');
  });

  function interact() { setTimeout(function () { syncDot(true); }, 0); }
  ['mouseover', 'mouseout', 'focusin', 'focusout'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (e.target.closest && e.target.closest('.header__inline-menu')) interact();
    });
  });
  document.addEventListener('toggle', function (e) {
    if (e.target.closest && e.target.closest('.header__inline-menu')) interact();
  }, true);

  var t;
  function later() { clearTimeout(t); t = setTimeout(place, 100); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place); else place();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(place);
  window.addEventListener('load', place);
  window.addEventListener('resize', later);
  var header = null;
  var headerObserver = window.MutationObserver ? new MutationObserver(later) : null;
  function observeHeader() {
    var current = document.querySelector('.header');
    if (!headerObserver || current === header) return;
    headerObserver.disconnect();
    header = current;
    if (header) headerObserver.observe(header, { attributes: true, attributeFilter: ['class'] });
    place();
  }
  observeHeader();
  document.addEventListener('shopify:section:load', observeHeader);
})();
